import { PageBumper, PageBumperProps } from '@/components/_rebrand/PageBumper';
import Image from 'next/image';

const displayProps = {
  title: 'Ready to deliver exceptional service with Front?',
  links: [
    {
      type: 'primary',
      title: 'Request a demo',
      href: '',
      action: 'demo',
    },
    {
      type: 'secondary',
      title: 'Try for free',
      href: '',
      action: 'trial',
    },
  ],
  styleOverrides: undefined,
} as PageBumperProps;


const Bumper = ({ entry }) => {

  displayProps.title = (entry.headline && entry.headline.length) ? entry.headline : displayProps.title;
  displayProps.styleOverrides = {
    bottomMarginSpacing: 'none',
    topMarginSpacing: 'none'
  };

  if (entry.supportingImage) {
    const supportingImage = entry.supportingImage[0];

    displayProps.staticImage = (
      <Image
        src={supportingImage.url}
        alt={supportingImage.alt}
        className="max-h-[322px] w-full"
        width={supportingImage.width}
        height={supportingImage.height}
      />
    );
  }

  return (
    <PageBumper {...displayProps} />
  );
};

export default Bumper;
